import { render } from "./DataProtectionSection.vue?vue&type=template&id=38000e8f&scoped=true&ts=true"
import script from "./DataProtectionSection.vue?vue&type=script&lang=ts"
export * from "./DataProtectionSection.vue?vue&type=script&lang=ts"

import "./DataProtectionSection.vue?vue&type=style&index=0&id=38000e8f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38000e8f"]])

export default __exports__